var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "formValidation",
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ pristine, handleSubmit, invalid }) {
          return [
            _c(
              "form",
              {
                staticClass: "invites form-horizontal",
                attrs: { role: "form" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return handleSubmit(_vm.onSaveAll)
                  }
                }
              },
              [
                _c(
                  "fieldset",
                  [
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("USER_EMAIL_ADDRESS"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("USER_EMAIL_ADDRESS_TT")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  attrs: {
                                    slim: "",
                                    rules: "required|email",
                                    vid: "confirmEmail"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ valid, dirty }) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-sm-5 col-md-4"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.email,
                                                      expression: "email"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    id: "emailInput",
                                                    placeholder: _vm.$t(
                                                      "USER_EMAIL_ADDRESS_DEFAULT"
                                                    ),
                                                    type: "email",
                                                    autocomplete: "off",
                                                    required: "true"
                                                  },
                                                  domProps: {
                                                    value: _vm.email
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.email =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _vm.existingUsers.length
                                                  ? _c("Typeahead", {
                                                      attrs: {
                                                        target: "#emailInput",
                                                        data: _vm.existingUsers,
                                                        "item-key": "email"
                                                      },
                                                      on: {
                                                        input: _vm.onEmailChange
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "item",
                                                            fn: function({
                                                              items,
                                                              activeIndex,
                                                              select
                                                            }) {
                                                              return _vm._l(
                                                                items,
                                                                function(
                                                                  user,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "li",
                                                                    {
                                                                      key:
                                                                        user.email,
                                                                      class: {
                                                                        active:
                                                                          activeIndex ===
                                                                          index
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "a",
                                                                        {
                                                                          attrs: {
                                                                            href:
                                                                              "#"
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              $event.preventDefault()
                                                                              return select(
                                                                                user
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._l(
                                                                            _vm.splitMatches(
                                                                              user.email,
                                                                              _vm.email
                                                                            ),
                                                                            function(
                                                                              piece,
                                                                              pieceIndex
                                                                            ) {
                                                                              return [
                                                                                piece.isMatch
                                                                                  ? _c(
                                                                                      "b",
                                                                                      {
                                                                                        key: pieceIndex
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            piece.text
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _c(
                                                                                      "span",
                                                                                      {
                                                                                        key: pieceIndex
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            piece.text
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                              ]
                                                                            }
                                                                          )
                                                                        ],
                                                                        2
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              )
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                      model: {
                                                        value: _vm.email,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.email = $$v
                                                        },
                                                        expression: "email"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                dirty && !valid
                                                  ? _c("span", {
                                                      directives: [
                                                        {
                                                          name: "t",
                                                          rawName: "v-t",
                                                          value:
                                                            "USER_INVALID_EMAIL",
                                                          expression:
                                                            "'USER_INVALID_EMAIL'"
                                                        }
                                                      ],
                                                      staticClass: "text-danger"
                                                    })
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("USER_EMAIL_CONFIRM"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("USER_EMAIL_CONFIRM_TT")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  attrs: {
                                    slim: "",
                                    rules:
                                      "required|email|confirmed:confirmEmail"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ valid, dirty }) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-sm-5 col-md-4"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.confirmEmail,
                                                      expression: "confirmEmail"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    "data-testid":
                                                      "confirm-email",
                                                    placeholder: _vm.$t(
                                                      "USER_EMAIL_ADDRESS_DEFAULT"
                                                    ),
                                                    type: "email",
                                                    autocomplete: "off",
                                                    required: "true"
                                                  },
                                                  domProps: {
                                                    value: _vm.confirmEmail
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.confirmEmail =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                dirty && !valid
                                                  ? _c("span", {
                                                      directives: [
                                                        {
                                                          name: "t",
                                                          rawName: "v-t",
                                                          value:
                                                            "USER_INVALID_CONFIRM_EMAIL",
                                                          expression:
                                                            "'USER_INVALID_CONFIRM_EMAIL'"
                                                        }
                                                      ],
                                                      staticClass: "text-danger"
                                                    })
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("FIRST_NAME"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("FIRST_NAME_TT")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c(
                                  "ValidationProvider",
                                  { attrs: { slim: "", rules: "required" } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col-sm-5 col-md-4" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.firstName,
                                              expression: "firstName"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            "data-testid": "first-name",
                                            type: "text",
                                            required: "true",
                                            placeholder: _vm.$t(
                                              "USER_FIRST_NAME_DEFAULT"
                                            )
                                          },
                                          domProps: { value: _vm.firstName },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.firstName =
                                                $event.target.value
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("LAST_NAME"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("LAST_NAME_TT")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c(
                                  "ValidationProvider",
                                  { attrs: { slim: "", rules: "required" } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col-sm-5 col-md-4" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.lastName,
                                              expression: "lastName"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            "data-testid": "last-name",
                                            type: "text",
                                            required: "true",
                                            placeholder: _vm.$t(
                                              "USER_LAST_NAME_DEFAULT"
                                            )
                                          },
                                          domProps: { value: _vm.lastName },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.lastName = $event.target.value
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-sm-offset-3 col-md-offset-3 col-md-8 col-sm-8"
                        },
                        [
                          _c(
                            "PrimaryButton",
                            {
                              attrs: {
                                disabled: pristine || invalid,
                                "show-loader-on-form": _vm.showLoader,
                                size: "sm",
                                "data-testid": "submit"
                              },
                              on: { click: _vm.submit }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("INVITE_USER_SUBMIT_BUTTON")) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("button", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "CANCEL",
                                expression: "'CANCEL'"
                              }
                            ],
                            staticClass: "btn btn-sm btn-danger m-l-15",
                            on: {
                              click: function($event) {
                                return _vm.$emit("cancel")
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }